import Menu from 'models/Menu';
import MenuData from 'models/MenuData';
import Breadcrumb from 'models/Breadcrumb';

function getBreadcrumbBasedOnUrl(menu : MenuData, url : string) : Breadcrumb {

  const apps = menu.applications.filter((x) => !x.status);
  if(!apps || apps.length === 0) return { } as Breadcrumb;

  const completeUrl = normalizeUrl(url);

  let history = {} as Breadcrumb;

  apps.forEach((app) => {
    if(!app?.menu) return;
    if(Object.keys(app.menu).length === 0) return;

    app.menu.forEach((x: Menu) => {

      if(Object.keys(history).length !== 0)
        return;

      const breadcrumb = ` / ${x.name}`;

      if(!isDropdownMenu(x)) {
        if(includesUrl(x, completeUrl))
          history = {
            noun: app.noun,
            breadcrumb: breadcrumb
          };

        return;
      }

      const menu = x.menu.filter((y : Menu) => includesUrl(y, completeUrl));
      if(isMenuEmpty(menu))
        return;

      history = {
        noun: app.noun,
        breadcrumb: `${breadcrumb} / ${menu[0].name}`
      };
    });
  });

  return history;
}

function normalizeUrl(url : string, includeProtocol = true) : string {
  const ignore = ['pt-BR', 'es-AR', 'es-CO', 'es-MX', 'es-EC'];

  const normalizedUrl = new URL(url);
  let pathname = normalizedUrl.pathname;

  ignore.forEach((x) => {
    pathname = pathname.
      replace(`/${x}/`, '/')
      .replace(`/${x.toLocaleLowerCase()}/`, '/');
  });

  const uri = `${normalizedUrl.host}${pathname}`;

  if(includeProtocol)
    return `${normalizedUrl.protocol}//${uri}`;

  return uri;
}

function isDropdownMenu(menu : Menu) : boolean {
  return menu.menu !== undefined;
}

function includesUrl(menu : Menu, url : string) : boolean {
  const menuUrl = normalizeUrl(menu.url);

  if (!menuUrl) return false;
  if (menuUrl === url) return true;

  if(new URL(menu.url).searchParams.toString().includes('http'))
    return menu.url.includes(normalizeUrl(url, false));

  return false;
}

function isMenuEmpty(menu : Menu[]) : boolean {
  return !menu || menu.length === 0;
}

export default getBreadcrumbBasedOnUrl;